import { type CurrencyEnum, type Transaction } from "@finway-group/shared/lib/models"

export const isTransactionArchived = (transaction: Pick<Transaction, "isArchived">) => transaction.isArchived

export const isTransactionManuallyUnarchived = (transaction: Pick<Transaction, "isAutoArchiveOff">) => transaction.isAutoArchiveOff

export const getVendorIdsFromTransactions = (transactions: Array<Transaction>) => transactions.map((transaction) => transaction.transactionData.vendor).filter((vendor) => vendor)

export const shouldDisplayTransactionConversion = (transaction: Transaction, expenseCurrency?: CurrencyEnum): expenseCurrency is CurrencyEnum => {
    if (!expenseCurrency) {
        return false
    }

    const bookedCurrency = transaction.transactionData?.currency
    if (expenseCurrency !== bookedCurrency) {
        return true
    }

    return Boolean(transaction.sourceCurrency && expenseCurrency !== transaction.sourceCurrency)
}

export const getTransactionDetailsSourceCurrency = (transaction: Transaction, expenseCurrency?: CurrencyEnum): CurrencyEnum | undefined => {
    return transaction.sourceCurrency && transaction.transactionData?.currency !== transaction.sourceCurrency ? transaction.sourceCurrency : expenseCurrency
}
